import * as yup from 'yup';

export const validation = yup.object().shape({
  td_id: yup
    .number()
    .typeError("El Tipo de Documento debe ser un número")
    .required("El Tipo de Documento es obligatorio"),

  tipoiva_id: yup
    .number()
    .typeError("La Condición Fiscal debe ser un número")
    .required("La Condición Fiscal es obligatoria"),

  cli_cuit: yup
    .string()
    .typeError("El Número de Documento debe ser un número")
    .required("El Número de Documento es obligatorio")
    .matches(/^\d+$/, "El Número de Documento solo debe contener dígitos")
    .when("tipoiva_id", {
      is: (val) => val === 1 || val === 5, // Responsable Inscripto o Monotributista → CUIT
      then: (schema) =>
        schema
          .min(11, "El CUIT debe tener exactamente 11 dígitos")
          .max(11, "El CUIT debe tener exactamente 11 dígitos"),
     is: (val) => val === 2, // SI TIENE DNI 
      then: (schema) =>
        schema
          .min(8, "El DNI debe tener exactamente 8 dígitos")
          .max(8, "El DNI debe tener exactamente 8 dígitos"),
    }),

  // opcionales
  razon_social: yup.string().nullable(),

  cli_tel: yup
    .string()
    .required("El Teléfono es obligatorio")
    .matches(
      /^(\+54)?\s*9?\s*\d{2,4}\s*\d{6,8}$/,
      "Teléfono inválido. Formato esperado: 111 1234567"
    ),
});